import { render, staticRenderFns } from "./NewRegistrationConfirm.vue?vue&type=template&id=4438b26a&scoped=true&"
import script from "./NewRegistrationConfirm.vue?vue&type=script&lang=js&"
export * from "./NewRegistrationConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4438b26a",
  null
  
)

export default component.exports